import egumaReact from "egumaReact"; // added in externals in webpack
import React, { Fragment } from "react";
import Polyglot from "node-polyglot";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import "./styles.css";

const polyglot = new Polyglot({ phrases: egumaReact.translations });

const mapTicketstoGroups = (tickets, groups) => {
  const matchedGroups = {};
  groups.forEach(g => (matchedGroups[g.id] = { group: g, tickets: [] }));
  tickets.forEach(t => matchedGroups[t.group]["tickets"].push(t));
  return Object.values(matchedGroups);
};

const TicketsAccordion = ({
  handleChange,
  selectedTickets,
  tickets,
  groups
}) => {
  if (tickets.length === 0) {
    return null;
  }

  const matchedGroups = mapTicketstoGroups(tickets, groups);

  return (
    <Fragment>
      <div className="ticket-groups-title">
        {polyglot.t("Common.Selection")}
      </div>
      {matchedGroups.map(
        g =>
          g.tickets.length > 0 && (
            <div
              className="product-ticket-group border-color"
              key={"group_" + g.group.id}
            >
              <Accordion defaultActiveKey={g.group.isOpenInShop ? "0" : null}>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="0"
                  className={
                    "product-ticket-group-header button-secondary-background-color button-secondary-color"
                  }
                >
                  <i className="fa-solid fa-angle-down" aria-hidden="true"></i>{" "}
                  <span dangerouslySetInnerHTML={{ __html: g.group.name }} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <div className="product-ticket-group-content">
                    <table
                      className="table"
                      style={{ marginTop: 0, marginBottom: 0 }}
                    >
                      <thead>
                        <tr style={{ height: 25 }}>
                          <th>
                            <strong>
                              <span id="event-details-ticket-type-title">
                                {polyglot.t("Common.Category")}
                              </span>
                            </strong>
                          </th>
                          <th style={{ textAlign: "right", minWidth: 126 }}>
                            <span className="event-details-price">
                              <strong>{polyglot.t("Common.Price")}</strong>
                              <span style={{ fontSize: "0.7em" }}>
                                {" "}
                                {polyglot.t("Bill.VatIncluded")}
                              </span>
                            </span>
                          </th>
                          <th style={{ textAlign: "right" }}>
                            <strong>{polyglot.t("Common.Quantity")}</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {g.tickets.map(ticket => (
                          <tr key={ticket.id} style={{ height: 45 }}>
                            <td>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: ticket.name
                                }}
                              />
                              <div
                                id="ticket-type-description"
                                style={{
                                  marginTop: 4,
                                  fontSize: "0.8em"
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: ticket.description
                                }}
                              />
                            </td>

                            <td className="text-right text-nowrap">
                              <span className="event-details-price">
                                {ticket.priceFormatted}
                              </span>
                            </td>

                            <td className="text-right">
                              {ticket.isSoldOut ? (
                                <span style={{ color: "#da3856" }}>
                                  <strong>
                                    {polyglot.t("Common.SoldOut")}
                                  </strong>
                                </span>
                              ) : (
                                <select
                                  id={ticket.id}
                                  name={ticket.nameForSelectTag}
                                  onChange={e =>
                                    handleChange(ticket.id, e.target.value)
                                  }
                                  style={{
                                    height: 34,
                                    width: "auto",
                                    minWidth: 53
                                  }}
                                  value={selectedTickets[ticket.id]}
                                >
                                  {ticket.quantities.map(qty => (
                                    <option
                                      key={"ticket_option_" + qty}
                                      value={qty}
                                    >
                                      {qty}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Accordion.Collapse>
              </Accordion>
            </div>
          )
      )}
    </Fragment>
  );
};

export default TicketsAccordion;
